<!-- Outer Container: Full Screen -->
<div class="w-full h-[calc(85vh-64px)] bg-white flex flex-col overflow-hidden">

  <!-- HEADER -->
  <div class="p-4 border-b border-gray-100 bg-white z-10 shrink-0">
    <div class="flex justify-between items-center">
      <div>
        <h2 class="text-2xl font-bold text-[#c19725] tracking-tight">GST Access Control</h2>
        <p class="text-gray-400 text-sm hidden md:block">Assign visibility permissions for GST staff members</p>
        <p class="text-gray-400 text-xs md:hidden">Manage GST user permissions</p>
      </div>
    </div>
  </div>

  <!-- LOADING STATE -->
  <div *ngIf="isLoading" class="flex-1 flex flex-col items-center justify-center bg-gray-50/50">
    <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-[#c19725]"></div>
    <p class="mt-4 text-[#c19725] font-medium">Loading...</p>
  </div>

  <!-- CONTENT AREA -->
  <div *ngIf="activeUserId && !isLoading" class="flex-1 flex overflow-hidden relative">

    <!-- LEFT SIDEBAR (Module List) -->
    <div
      class="w-full md:w-1/4 min-w-[250px] bg-gray-50 border-r border-gray-200 overflow-y-auto custom-scrollbar transition-all duration-300 md:block"
      [class.hidden]="showMobileDetails">

      <div
        class="p-4 bg-gray-100/80 border-b border-gray-200 text-xs font-bold text-gray-500 uppercase tracking-wider sticky top-0 backdrop-blur-sm z-10">
        Select Module
      </div>

      <div class="flex flex-col pb-20 md:pb-0">
        <div *ngFor="let menu of navbarOptions; let i = index" (click)="setActiveMenu(i)"
          class="cursor-pointer group relative border-l-4 transition-all duration-200 ease-in-out flex items-center justify-between p-4 hover:bg-white border-b border-gray-100 md:border-b-0"
          [ngClass]="activeMenuIndex === i ? 'bg-white border-[#c19725] shadow-sm' : 'border-transparent text-gray-600'">

          <div class="flex items-center gap-3 overflow-hidden">
            <div (click)="$event.stopPropagation()">
              <input type="checkbox" [checked]="isMainChecked(menu.path)" (change)="toggleMain(menu.path, $event)"
                class="w-5 h-5 rounded border-gray-300 text-[#c19725] focus:ring-[#c19725] cursor-pointer">
            </div>

            <span class="font-medium truncate transition-colors text-base md:text-sm"
              [ngClass]="activeMenuIndex === i ? 'text-[#c19725]' : 'group-hover:text-gray-900'">
              {{ menu.lable }}
            </span>
          </div>

          <!-- Chevron Icon -->
          <svg class="w-5 h-5 text-gray-300" [ngClass]="{'text-[#c19725]': activeMenuIndex === i}" fill="none"
            stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
          </svg>
        </div>
      </div>
    </div>

    <!-- RIGHT PANEL (Details) -->
    <div class="w-full md:flex-1 bg-white overflow-y-auto p-4 md:p-10 flex-col md:flex"
      [class.hidden]="!showMobileDetails">

      <ng-container *ngIf="navbarOptions[activeMenuIndex] as activeItem">

        <!-- MOBILE BACK BUTTON HEADER -->
        <div class="md:hidden mb-4 pb-2 border-b border-gray-100 flex items-center gap-2">
          <button (click)="backToMobileList()" class="p-2 -ml-2 text-gray-600 hover:text-[#c19725]">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
            </svg>
          </button>
          <span class="font-bold text-gray-800">Back to Modules</span>
        </div>

        <!-- Selection Info -->
        <div class="mb-6 md:mb-8 pb-4 border-b border-gray-100">
          <div class="flex items-center gap-2 mb-2">
            <span class="text-xs font-bold text-gray-400 uppercase tracking-wider">Status</span>
            <span *ngIf="!isMainChecked(activeItem.path)"
              class="text-[10px] bg-red-100 text-red-600 px-2 py-0.5 rounded-full font-bold uppercase tracking-wide">
              Hidden
            </span>
            <span *ngIf="isMainChecked(activeItem.path)"
              class="text-[10px] bg-green-100 text-green-600 px-2 py-0.5 rounded-full font-bold uppercase tracking-wide">
              Visible
            </span>
          </div>

          <h3 class="text-2xl md:text-4xl font-bold text-c19725">
            {{ activeItem.lable }}
          </h3>
          <p class="text-gray-500 mt-2 text-sm md:text-base">
            Control specific submenu visibility. Or (Depend panel marked as * )
          </p>
        </div>

        <div *ngIf="activeItem.submenu && activeItem.submenu.length > 0"
          class="flex items-center justify-end mb-4 px-1">

          <!-- Select All Button -->
          <button type="button"
            (click)="toggleAllSubmenus(activeItem.submenu, { target: { checked: !areAllSubmenusChecked(activeItem.submenu) } })"
            class="flex items-center gap-2 px-4 py-1.5 rounded-full text-sm font-medium border transition-all"
            [ngClass]="areAllSubmenusChecked(activeItem.submenu)
              ? 'bg-[#c19725] text-white border-[#c19725]'
              : 'bg-white text-[#c19725] border-[#c19725] hover:bg-[#c19725] hover:text-white'">
            <span>
              {{ areAllSubmenusChecked(activeItem.submenu) ? 'Unselect All' : 'Select All' }}
            </span>
            <span class="text-xs opacity-80">
              ({{ activeItem.submenu.length }})
            </span>
          </button>

        </div>

        <!-- Submenu Grid -->
        <div class="flex-1 pb-20 md:pb-0">
          <div *ngIf="activeItem.submenu && activeItem.submenu.length > 0; else noSubmenu"
            class="grid grid-cols-1 xl:grid-cols-2 gap-3 md:gap-4">

            <div *ngFor="let sub of activeItem.submenu"
              class="flex items-center p-4 rounded-lg border border-gray-100 hover:border-[#c19725]/40 hover:shadow-md transition-all duration-200 bg-gray-50/30 group active:bg-gray-100">

              <!-- MAIN SUBMENU CHECKBOX -->
              <div class="flex-shrink-0 mr-4">
                <input type="checkbox" [id]="sub.path" [checked]="isSubChecked(sub.path)"
                  (change)="toggleSub(sub, $event)"
                  class="w-6 h-6 rounded border-gray-300 text-[#c19725] focus:ring-[#c19725] cursor-pointer">
              </div>

              <!-- LABEL -->
              <label [for]="sub.path" class="flex-1 cursor-pointer select-none">
                <span
                  class="block text-base md:text-lg font-semibold text-gray-700 group-hover:text-[#c19725] transition-colors">
                  {{ sub.lable }}
                </span>
              </label>

              <!-- UPDATE / DELETE -->
              <div *ngIf="shouldShowActionPermissions(sub.path)"
                class="flex items-center gap-3 md:gap-4 ml-2 transition-opacity duration-200" [ngClass]="{
                  'opacity-30 pointer-events-none': !isSubChecked(sub.path)
                }">

                <!-- UPDATE -->
                <div class="flex flex-col items-center gap-1">
                  <input type="checkbox" [id]="'update-' + sub.path" [checked]="isUpdateChecked(sub.updatePermission)"
                    (change)="toggleUpdate(sub.updatePermission, $event)"
                    class="w-4 h-4 rounded border-gray-300 text-blue-500 focus:ring-blue-500 cursor-pointer">
                  <label [for]="'update-' + sub.path" class="text-[10px] font-bold text-blue-500 uppercase">
                    Update
                  </label>
                </div>

                <!-- DELETE -->
                <div class="flex flex-col items-center gap-1">
                  <input type="checkbox" [id]="'delete-' + sub.path" [checked]="isDeleteChecked(sub.deletePermission)"
                    (change)="toggleDelete(sub.deletePermission, $event)"
                    class="w-4 h-4 rounded border-gray-300 text-red-500 focus:ring-red-500 cursor-pointer">
                  <label [for]="'delete-' + sub.path" class="text-[10px] font-bold text-red-500 uppercase">
                    Delete
                  </label>
                </div>
              </div>

            </div>
          </div>

          <ng-template #noSubmenu>
            <div
              class="flex flex-col items-center justify-center text-center border-2 border-dashed border-gray-100 rounded-xl bg-gray-50/30 p-8 mt-4">
              <svg class="w-16 h-16 text-gray-200 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z">
                </path>
              </svg>
              <p class="text-lg font-medium text-gray-500">No sub-modules</p>
              <p class="text-sm text-gray-400 mt-1">Controlled by Main checkbox.</p>
            </div>
          </ng-template>
        </div>

      </ng-container>

    </div>

  </div>

  <!-- FOOTER -->
  <div *ngIf="activeUserId && !isLoading"
    class="bg-white border-t border-gray-200 p-4 shrink-0 flex flex-row justify-between items-center z-30 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.05)] md:static fixed bottom-0 left-0 w-full md:w-auto">

    <!-- NAME -->
    <div class="flex items-center gap-3">

      <!-- USER IMAGE -->
      <img [src]="activeUserImage || '/assets/images/user/user-profile.png'" alt="User"
        class="w-10 h-10 md:w-12 md:h-12 rounded-full object-cover border-2 border-[#c19725] shadow-sm" />

      <!-- USER INFO -->
      <div class="flex flex-col">
        <span class="text-[10px] text-gray-400 font-bold uppercase tracking-wider">
          Editing For
        </span>
        <div class="text-sm md:text-lg font-bold text-[#c19725] truncate max-w-[150px] md:max-w-none">
          {{ activeUserName }} {{ activeUserLastName }}
        </div>
      </div>
    </div>

    <div class="flex items-center gap-3">
      <!-- BACK BUTTON -->
      <button (click)="goBack()"
        class="px-5 py-2.5 md:px-6 md:py-3 bg-white border border-[#c19725] text-[#c19725] hover:bg-[#f6f1cb] font-bold rounded-lg transition-all duration-200 text-sm md:text-base">
        Back
      </button>

      <!-- SAVE BUTTON -->
      <button (click)="savePermissions()"
        class="px-6 py-2.5 md:px-8 md:py-3 bg-[#c19725] hover:bg-[#a6821f] text-white font-bold rounded-lg shadow-lg transform active:scale-95 transition-all duration-200 flex items-center gap-2 text-sm md:text-base">
        <svg class="w-4 h-4 md:w-5 md:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4">
          </path>
        </svg>
        Save
      </button>
    </div>
  </div>
</div>
